import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_STOCK_PRESUNTO_TERMINAL } from '../../../../../config/tables'

export default function StockPresuntoTerminalView () {
  return <MuiTable id={TABLA_STOCK_PRESUNTO_TERMINAL} />
}
